const GET_BRAND_CRM = {
  REQUEST: "GET_BRAND_CRM_REQUEST",
  SUCCESS: "GET_BRAND_CRM_SUCCESS",
  ERROR: "GET_BRAND_CRM_ERROR",
};

const SAVE_BRAND_CRM = {
  REQUEST: "SAVE_BRAND_CRM_REQUEST",
  SUCCESS: "SAVE_BRAND_CRM_SUCCESS",
  ERROR: "SAVE_BRAND_CRM_ERROR",
  RESET: "SAVE_BRAND_CRM_RESET",
};

const TEST_BRAND_CRM = {
  REQUEST: "TEST_BRAND_CRM_REQUEST",
  SUCCESS: "TEST_BRAND_CRM_SUCCESS",
  ERROR: "TEST_BRAND_CRM_ERROR",
  RESET: "TEST_BRAND_CRM_RESET",
};

const DELETE_BRAND_CRM = {
  REQUEST: "DELETE_BRAND_CRM_REQUEST",
  SUCCESS: "DELETE_BRAND_CRM_SUCCESS",
  ERROR: "DELETE_BRAND_CRM_ERROR",
  RESET: "DELETE_BRAND_CRM_RESET",
};

export { GET_BRAND_CRM, SAVE_BRAND_CRM, TEST_BRAND_CRM, DELETE_BRAND_CRM };
